import Address from './Address';
import CDN from './CDN';
import Change from './Change';
import ChartAlt from './ChartAlt';
import Chat from './Chat';
import Checkmark from './Checkmark';
import Close from './Close';
import Compliance from './Compliance';
import Copy from './Copy';
import DayNight from './DayNight';
import Delete from './Delete';
import Design from './Design';
import Development from './Development';
import DollarSign from './DollarSign';
import Download from './Download';
import Drag from './Drag';
import Duplicate from './Duplicate';
import ExternalLink from './ExternalLink';
import Filter from './Filter';
import Fire from './Fire';
import Font from './Font';
import GenerateKeywords from './GenerateKeywords';
import Globe from './Globe';
import Groups from './Groups';
import Growth from './Growth';
import HeartPulse from './HeartPulse';
import Import from './Import';
import List from './List';
import Logout from './Logout';
import Mail from './Mail';
import Merge from './Merge';
import Minus from './Minus';
import MobileDevices from './MobileDevices';
import Paperclip from './Paperclip';
import Past from './Past';
import Phone from './Phone';
import Plus from './Plus';
import PreviewCrossed from './PreviewCrossed';
import Radio from './Radio';
import Reload from './Reload';
import Retransmit from './Retransmit';
import RowAdd from './RowAdd';
import RowRemove from './RowRemove';
import Rows from './Rows';
import RSS from './RSS';
import Running from './Running';
import Search from './Search';
import SidebarToggle from './SidebarToggle';
import SortingOff from './SortingOff';
import Spinner from './Spinner';
import Translate from './Translate';
import Upload from './Upload';
export const DefaultIcons = {
    Address,
    CDN,
    Change,
    ChartAlt,
    Chat,
    Checkmark,
    Close,
    Compliance,
    Copy,
    DayNight,
    Delete,
    Design,
    Development,
    DollarSign,
    Download,
    Drag,
    Duplicate,
    ExternalLink,
    Filter,
    Font,
    GenerateKeywords,
    Globe,
    Groups,
    HeartPulse,
    Import,
    List,
    Logout,
    Mail,
    Merge,
    Minus,
    MobileDevices,
    Paperclip,
    Past,
    Phone,
    Plus,
    PreviewCrossed,
    Radio,
    Reload,
    Retransmit,
    RowAdd,
    RowRemove,
    Rows,
    RSS,
    Running,
    Search,
    SidebarToggle,
    SortingOff,
    Spinner,
    Translate,
    Growth,
    Fire,
    Upload,
};
export default DefaultIcons;
